<div
  (mousemove)="setEvent($event)"
  [attr.id]="key" [ngClass]="class"
  class="chart-area chart_height_xxs"
>
</div>
